import React, { useCallback, useMemo, useState } from "react";
import { Typography } from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

import { updateUser } from "../../../../sevices/apiUser";
import { objectToFormData } from "../../../../utils";
import { localStorageInstance } from "../../../../utils/localStorage";
import FormDialog from "../../../../components/Dialog/FormDialog";
import useMutate from "../../../../hooks/useMutate";
import { currentUserId } from "../../../../utils/constants";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";

function Active({ isActive, id }) {
  const [status, setStatus] = useState(isActive);
  const [loading, setLoading] = useState(false);
  const [activeDialog, setActiveDialog] = useState(false);
  const userId = currentUserId();

  const handleCloseDialog = useCallback(() => {
    setActiveDialog(false);
  }, []);

  const { mutate: userMutate } = useMutate(updateUser,["users"],() => {},
     () => {
      setStatus((data) => !data);
      setLoading(false);
      handleCloseDialog();
    },
    () => {
      setLoading(false);
      handleCloseDialog();
    });

  const handleActiveUser = useCallback(() => {
    const data = objectToFormData({ active: !isActive });
    setLoading(true);
    userMutate({ id, data });
  }, [isActive, id, userMutate]);

  const dialogTitle = useMemo(() => {
    return isActive
      ? "Confirmation: Disable User"
      : "Confirmation: Enable User";
  }, [isActive]);

  const dialogMessage = useMemo(() => {
    return isActive
      ? "Are you sure you want to Disable this user?"
      : "Are you sure you want to Enable this user?";
  }, [isActive]);

  return (
    <>
      {userId !== id && (
        <CustomMenuItem
          onClick={(e) => {
            userId !== id && setActiveDialog(true);
          }}
        >
          <PersonOffOutlinedIcon className="user-management-action-icon mr-2"/>
          <p>{status ? "Disable" : "Enable"}</p>
          {activeDialog && (
            <FormDialog
              open={activeDialog}
              handleClose={handleCloseDialog}
              loading={loading}
              handleSubmit={handleActiveUser}
              buttonTxt={isActive ? "Disable" : "Enable"}
              cancelBtn={true}
              title={dialogTitle}
            >
              <Typography className="align_text_center mb-2 ">
                {dialogMessage}
              </Typography>
            </FormDialog>
          )}
        </CustomMenuItem>
      )}
    </>
  );
}

export default React.memo(Active);
